import { Login, Health, PasswordReset, PasswordResetRequest, RegisterForm } from 'pages/Authentication';

const authRoutes = [
  { path: '/login', component: Login, exact: true, strict: true },
  { path: '/health', component: Health, exact: true, strict: true },
  { path: '/resetPassword', component: PasswordReset, exact: true, strict: true },
  { path: '/resetPasswordRequest', component: PasswordResetRequest, exact: true, strict: true },
  { path: '/register', component: RegisterForm, exact: true, strict: true },
];

export default authRoutes;
